/* global axios */
import ApiClient from '../ApiClient';

class StudioFlow extends ApiClient {
  constructor() {
    super('ai/flows', { accountScoped: true });
  }

  // captain/storeFactory passa { page, searchKey } como argumento.
  // Aceitamos os filtros do backend (Ai::FlowsController#index):
  //   `mode`       voice/text — particiona a listagem por modalidade;
  //   `purpose`    main/campaign — jornada principal vs. jornada de campanha;
  //   `production` só os fluxos da versão que ATENDE hoje (production_version).
  // Quem escolhe fluxo pra rodar em produção (picker do Kanban) precisa dos
  // três — sem `production` a lista traz rascunho e versão aposentada.
  get({ page = 1, searchKey, mode, purpose, production } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey, mode, purpose, production },
    });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, data);
  }

  compile(id) {
    return axios.post(`${this.url}/${id}/compile`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  // "O que chega neste nó": contrato de variáveis disponíveis no ponto do
  // canvas. `subFlowId` porque cada aba do builder é um grafo próprio.
  availableVars(id, { nodeId, subFlowId } = {}) {
    return axios.get(`${this.url}/${id}/available_vars`, {
      params: { node_id: nodeId, sub_flow_id: subFlowId },
    });
  }

  // Ferramentas que cada agente TERÁ quando este grafo for sincronizado. O
  // `agent.tools` do registro é o artefato do último publish (e é compartilhado
  // entre versões do projeto) — aqui vem do grafo salvo.
  agentToolsPreview(id) {
    return axios.get(`${this.url}/${id}/agent_tools_preview`);
  }
}

export default new StudioFlow();
